import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints';
import { File, Plus } from 'react-feather';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

export default function RightSlotEvent({ onCreateEventClick = () => false, onCreateDraftClick = () => false, hasEvents }) {
    return (
        <ActionsRow>
            <DraftButton onClick={() => onCreateDraftClick()} type="button">
                <File size={16} />
                <span>Rascunho</span>
            </DraftButton>

            {hasEvents && (
                <CreateButton onClick={() => onCreateEventClick()} type="button">
                    <Plus size={16} strokeWidth={2.5} />
                    <span>Criar evento</span>
                </CreateButton>
            )}
        </ActionsRow>
    )
}

const ActionsRow = styled.div`
    display: flex;
    gap: 8px;
    width: 100%;

    @media screen and (min-width: ${breakpoints.md}) {
        width: auto;
    }
`;

const DraftButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 38px;
    padding: 0 16px;
    border-radius: 10px;
    border: 1px solid ${colors.neutralDark};
    background: ${colors.neutralLight};
    color: ${colors.nightDark};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    flex: 1;

    & > svg {
        color: ${colors.night};
        transition: color 0.2s ease;
    }

    &:hover {
        border-color: ${colors.nightLight};
        background: ${colors.neutral};

        & > svg {
            color: ${colors.nightDark};
        }
    }

    &:active {
        transform: scale(0.97);
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex: none;
    }
`;

const CreateButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 38px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    background: ${colors.occasionalPurple};
    color: ${colors.neutralLight};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    flex: 1;

    & > svg {
        color: ${colors.neutralLight};
    }

    &:hover {
        background: #8A12BF;
        box-shadow: 0 2px 8px ${colors.occasionalPurple}30;
    }

    &:active {
        transform: scale(0.97);
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex: none;
    }
`;
